import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Scrollbars } from 'react-custom-scrollbars';
import Dfp from './Dfp';
import Sites from './Sites';
import Nav from './Nav';
import 'whatwg-fetch';

class Menu extends Component {
	constructor(){
		super();
		this.state = {
			list:[],
			footer_menu:[]
		}
		
		this.subCatMenuToggle = this.subCatMenuToggle.bind(this);
		this.menuToggle = this.menuToggle.bind(this);
		this.getMenu = this.getMenu.bind(this);
	}
	 
	getMenu(){
		const { theme } = this.props
		let that = this;
		
		
		if(document.getElementById('static-ads-leaderboard')){
			ReactDOM.render(
				<Dfp 
					adUnit={ theme+"_article_ATF_970x90" }
					sizes={[[970,90],[970,550],[970,250],[728,90],[728,180]]}
					sizeMapping={ [
						{viewport: [970, 0], sizes:[[728, 90],[728, 180],[970, 90]]},
						{viewport: [0, 0], sizes:[]}
						]}
				/>,
			  document.getElementById('static-ads-leaderboard')
			);
		}
		
		if(document.getElementById('static-ads-lrec')){
			ReactDOM.render(
				<div className="ad_300x250 text-center">
				<Dfp 
					adUnit={ theme+"_article_ATF_300x250" }
					sizes={[[300,250],[300,600]]}
				/>
				</div>,
			  document.getElementById('static-ads-lrec')
			);
		}
		
		fetch('/asset/'+theme+'/menu.json?t='+(new Date()).getTime(),{
			method:"GET"
			}).then(function(res){ 
				return res.json(); 
			})
			.then(function(response){
				let arr = response.items.main_menu;
				let footer_menu_arr = response.items.footer_menu;
				let social_menu_arr = response.items.social;
				that.setState({ list:arr,footer_menu:footer_menu_arr, social_menu:social_menu_arr });
				

				if(document.getElementById('top-navigation')){
					ReactDOM.render(
					  <Nav menudata={arr} theme={that.props.theme} catId={that.props.catId} postId={that.props.postId} baseurl={that.props.baseurl} />,
					  document.getElementById('top-navigation')
					);
				}
				
			}).catch(function(error){
				 console.log(error);
			});
	}
	 
	componentDidMount(){
		this.getMenu();
	}
	
	mainMenuToggle(evnt){
		
	}
	
	menuToggle(evnt){
		
		if(document.getElementById('menu-nav')){
			let elm = document.getElementById('menu-nav');
			if(elm.className.indexOf('open')!==-1){
				document.getElementById('menu-nav').className = '';
			}
		}
		
	}
	
	subCatMenuToggle(evnt){
		if(document.querySelectorAll('.sub-cat-menu.parent.open').length){
			let elm = document.querySelectorAll('.sub-cat-menu.parent.open')[0];
			elm.className = elm.className.replace('open','');
		}else{
			let dataset = evnt.currentTarget.dataset;
			
			let elm = document.getElementById(dataset.subcategory+'-subcat');
			if(elm.className.indexOf('open')<0){
				elm.className = elm.className+'open';
			}
		}
	}
	
	renderLogin(){
		const { baseurl, theme } = this.props;
		let memberCenter = JSON.parse(document.querySelector('meta[name="memberCenter"]').content);
		let memberInfo = document.querySelector('meta[name="memberInfo"]').content=='' ? '' : JSON.parse(document.querySelector('meta[name="memberInfo"]').content);
		let tmpHTML = '';
		let tmpURL = theme.indexOf('blog.she.com')==-1 ? memberCenter.profileUrl : baseurl+"/wp-login.php";
		
		if(memberInfo==''){
			tmpHTML = <div className="clearfix">
			   <a className="fixed-menu-item Abel" href={ memberCenter.signinUrl }>
				<span>login</span>
			   </a>
			   </div>
		}else{
			tmpHTML =
					<div className="clearfix">
						<div className="profile-pic">
							<a href={tmpURL}>
							<img src={memberInfo.profile_image} alt="profile"/></a>
						</div>
						<div className="profile-info">
							<a className="username Abel" href={tmpURL}>{memberInfo.nickname}</a>
							<a className="signout Abel" href={memberCenter.logoutUrl}>sign out</a>			
						</div>
					</div>
		}
		
		return tmpHTML;
	}
	
	render(){
		const { list, footer_menu, social_menu } = this.state;
		const { baseurl, theme } = this.props;
		let that = this;
		
		
		if(list.length){
			 return(
				<div id="menu-nav">
					<Scrollbars>
						<div className="btn-close-placeholder"></div>
						<div className="btn-close text-right"><i className="icon-close-01" onClick={this.menuToggle}></i></div>
						
						<Dfp 
							adUnit={theme+'_menu_ROS_245x100'}
							sizes={[[245,100]]}
						/>
						{
							list.map(function(item,index){
								return (
									<div key={index}>
										<div className="fixed-menu-item Abel">
											<a className="fixed-menu-item" href={item.url}>{item.title}</a>
											{
												( !item.hasOwnProperty('child') ?
												'' :
												<div className="sub-btn" data-subcategory={item.title} onClick={that.subCatMenuToggle}>
													<i className="subcat-icon icon-plus-01"></i>
												</div>)
											}
										</div>
										{
											( item.hasOwnProperty('child') ? 
											<div id={ item.title+'-subcat' } className="sub-cat-menu parent ">
												<div className="sub-inner-menu">
													<div className="btn-sub-close" onClick={that.subCatMenuToggle}>
														<i className="icon-arr_left-01"></i>
													</div>
													{
														item.hasOwnProperty('child') ?
															item.child.map(function(childItem, childIdx){
																return (
																	<div key={childIdx} className="subcat-menu-item">
																		<a className="Abel" href={ childItem.url }>
																			<span>{ childItem.title }</span>
																		</a>
																	</div>
																)
															})
															:
															''
													}
												</div>
											</div> :
											'')
										}
									</div>
								)
							})
						}
						<div id="login-block">
						{
							this.renderLogin()
						}
						</div>
						<div id="sns" className="clearfix">
							<div className="findus">find us on</div>
							<ul>
								<li><a href={social_menu.facebook} title="facebook" target="blank"><i className="icon-facebook"></i></a></li>
								<li><a href={social_menu.instagram} title="instagram" target="blank"><i className="icon-instagram"></i></a></li>
								<li><a href={social_menu.youtube} title="youtube" target="blank"><i className="icon-youtube-play"></i></a></li>
								<li><a href={social_menu.weibo} title="weibo" target="blank"><i className="icon-weibo"></i></a></li>
							</ul>
						</div>
						<Sites theme={theme}/>
						<div id="footer-menu" style={{borderTop:'1px solid #484848'}}>
						   {
							   footer_menu.map(function(item,idx){
								   return (
										<a key={idx} className="fixed-menu-item Abel" href={item.url}>{item.title}</a>
								   );
							   })
						   }
						   <p className="copyright menu-info Abel">
								copyright ©  2000-{(new Date().getFullYear())} she communications limited. all rights reserved
								<img src="/assets/img/icon-tom.svg" className="tom" alt="tomgroup"/>
							</p>
						</div>
					</Scrollbars>
				</div>
			 )
		}else{
			return <div></div>
		}
	}
}

export default Menu;


// WEBPACK FOOTER //
// ./src/Menu.js